import React, { useMemo } from 'react';

import { faTableList } from '~components/icon';
import { Row, TableView } from '~components/table-view';

import { CarePlanServiceLine } from '~clients/models';

import columnsFactory from '~clients/forms/care-plans/serviceLinesList';

interface ComponentProps {
  serviceLines: CarePlanServiceLine[];
  serviceTypesById: Map<number, string>;
  frequenciesById: Map<string, string>;
  goalLabelById: Map<string, string>;
  onEdit: (line: CarePlanServiceLine) => void;
  onDelete: (line: CarePlanServiceLine) => void;
  isSaving: boolean;
  isLoading: boolean;
}

/**
 * "List" view — a flat TableView of the plan's service lines. Reads the same data as the
 * By-goal view, so switching between the two never refetches.
 */
const ListView: React.FC<ComponentProps> = ({
  serviceLines,
  serviceTypesById,
  frequenciesById,
  goalLabelById,
  onEdit,
  onDelete,
  isSaving,
  isLoading,
}) => {
  const rows = useMemo(() => serviceLines as unknown as Row[], [serviceLines]);
  const columns = useMemo(
    () => columnsFactory(serviceTypesById, frequenciesById, goalLabelById, onEdit, onDelete, isSaving),
    [serviceTypesById, frequenciesById, goalLabelById, onEdit, onDelete, isSaving],
  );

  return (
    <TableView
      id="care-plan-service-lines-list"
      data={rows}
      columns={columns}
      isLoading={isLoading}
      emptyIcon={faTableList}
      emptyMessage="No services recorded."
      readonly
      striped
    />
  );
};

export default ListView;
